import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class CertificationsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'AssassmentSectionsStateModel';

    constructor() {
        super(CertificationsStateModel.identifier);
    }
}
